export const MAX_LENGTHS = {
  FIRST_NAME: 40,
  LAST_NAME: 40,
};

export const MESSAGES = {
  DISCARD_NAME_CHANGES: 'Are you sure you want to discard changes made to your name?',
  DISCARD_PHONE_NUMBER_CHANGES: 'Are you sure you want to discard changes made to your phone number?',
};
